import angular from 'angular';
import tcEmailComponent from './tc-email.component';

let tcEmailModule = angular.module('tcEmail', [])
  .component('tcEmail', tcEmailComponent);

export default tcEmailModule;




// WEBPACK FOOTER //
// ./client/common/directives/email/tc-email.js